module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.d53a63e3.svg";